import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";


export default function AdditionalLinks() {
    const navigate = useNavigate();
    return (
        <Grid container component={Paper} justifyContent={'flex-start' }>
            <Grid size={2}>
                <Button onClick={() => navigate("/cambourne")}>Cambourne Village Analysis</Button>
            </Grid>
            <Grid size={2}>
                <Button onClick={() => navigate("/travl/home")}>TRAVL</Button>
            </Grid>
        </Grid>
    );
}